import React, { useState } from 'react';
import { DialogTitle, DialogContent } from '@mui/material';
import Input from '../../../PublicSide/components/Input/Input';
import Button from '../../../PublicSide/components/Button/Button';
import SuccessErrorMessage from '../../components/SuccesErrorMessage/SuccessErrorMessage';
import { StyledBox, StyledButtonCancelSubmit, StyledDialogUserServer } from '../../../style/GlobalsComponentsStyled';

interface AddServerDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (applicationId: number, domainName: string, runnerName: string, ip: string, sshUser: string, sshPrivateKey: string, deployScript: string, comments: string) => void;
  applicationId: number;
}

const AddServerDialog: React.FC<AddServerDialogProps> = ({ open, onClose, onSubmit, applicationId }) => {
  const [domainName, setDomainName] = useState('');
  const [runnerName, setRunnerName] = useState('');
  const [ip, setIp] = useState('');
  const [sshUser, setSshUser] = useState('');
  const [sshPrivateKey, setSshPrivateKey] = useState('');
  const [deployScript, setDeployScript] = useState('');
  const [comments, setComments] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = () => {
    if (!domainName || !runnerName || !ip || !sshUser || !sshPrivateKey || !deployScript) {
      setErrorMessage('Please fill in all required fields.');
      return
    }
    else {
      onSubmit(applicationId, domainName, runnerName, ip, sshUser, sshPrivateKey, deployScript, comments);
      setDomainName('');
      setRunnerName('');
      setIp('');
      setSshUser('');
      setSshPrivateKey('');
      setDeployScript('');
      setComments('');
    }
  };

  return (
    <StyledDialogUserServer open={open} onClose={onClose}>
      <StyledBox>
        <DialogTitle>Add New Server</DialogTitle>
        <SuccessErrorMessage errorMessage={errorMessage} onClear={() => { setErrorMessage(''); }} sx={{ marginLeft: '10px !important', background: 'rgb(253, 237, 237) !important' }} />
        <DialogContent>
          <StyledBox>
            <Input label="Domain Name" value={domainName} onChange={(e) => setDomainName(e.target.value)} />
            <Input label="Runner Name" value={runnerName} onChange={(e) => setRunnerName(e.target.value)} />
            <Input label="IP Address" value={ip} onChange={(e) => setIp(e.target.value)} />
            <Input label="SSH User" value={sshUser} onChange={(e) => setSshUser(e.target.value)} />
            <Input label="SSH Private Key" value={sshPrivateKey} onChange={(e) => setSshPrivateKey(e.target.value)} type="password" />
            <Input label="Deploy Script" value={deployScript} onChange={(e) => setDeployScript(e.target.value)} />
            <Input label="Comments (Optional)" value={comments} onChange={(e) => setComments(e.target.value)} />
            <StyledButtonCancelSubmit>
              <Button text="Cancel" onClick={onClose} />
              <Button type="submit" text="Add" onClick={handleSubmit} />
            </StyledButtonCancelSubmit>
          </StyledBox>
        </DialogContent>
      </StyledBox>
    </StyledDialogUserServer>
  );
};

export default AddServerDialog;
